module.exports = __webpack_public_path__ + "quicksilver/static/media/sbi.b1897650.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/banking/sbi.svg
// module id = 639
// module chunks = 0